import './ui/more.css';

import { useContext, useEffect, useRef, useState } from 'react';

import { CreateSet, FlashDeck, Quiz } from './flashcards';
import { DeckDetails } from './flashsets';



export function Overlays({open}){
    // useEffect(() => {
    //     console.log(open);
    // })

    return (
        <>
            <Overlay component={CreateSet} name="create-set" />
            <Overlay component={FlashDeck} name="flashdeck" />
            <Overlay component={Quiz} name="quiz" />
            <Overlay component={DeckDetails} name="deck-details" />
        </>
    )


    function Overlay({component, name}){
        const show = open.get(name);

        return component({show: Boolean( show ), args: show})
    }
}